<section class=" bg-white fullwidth-section">
  <div class="app-container container-xl container-xl-max-md w-100 pb-lg-4">
    @if (isLoading()) {
    <ng-container *ngTemplateOutlet="skeletonGroup"></ng-container>
    <ng-container *ngTemplateOutlet="skeletonGroup"></ng-container>
    <div class="separator my-9"></div>
    <ng-container *ngTemplateOutlet="skeletonTable"></ng-container>
    } @else {
    <!-- Jump straight to a subject. The landing page has always had this strip;
         the page people actually land on when they click "คอร์สเรียน" had no
         category navigation at all, so choosing a subject meant scrolling past
         every other subject's rail to find it. -->
    @if (courseCategories.length > 1) {
    <nav class="course-jump pt-4  " data-testid="course-jump">
      @for (category of courseCategories; track category.id) {
      <a class="course-jump__item" [routerLink]="`/courses/category/${category.id}`">
        @if (art(category.name); as mark) {
        <span class="course-jump__mark"><img [src]="mark" alt="" /></span>
        }
        <span class="course-jump__name">{{ category.name }}</span>
      </a>
      }
    </nav>
    }

    @for (category of courseCategories; track category; let i = $index) {
    @if (category.recommend_courses.length) {
    <div class="pb-12">
      <div class="d-flex flex-row justify-content-between align-items-center pb-4">
        <p class="fs-1 fs-md-2 fw-bold mb-0 d-flex align-items-center gap-3">
          <!-- The same art the landing page puts on this category, so the
                   two screens name the same thing the same way. -->
          @if (art(category.name); as mark) {
          <span class="course-group__mark"><img [src]="mark" alt="" /></span>
          }
          <span>{{ "COURSES.RECOMMEND_COURSE" | translate }} : {{ category.name }}</span>
        </p>
        <!-- Always, not only past four courses. Every rail here holds two
                 or three, so the condition never fired and each rail was a
                 heading with an empty right half and no way out of it. Set as
                 the 2021 build set its "see all": a gold rule under a quiet
                 label, which is the one job that palette's accent had. -->
        <a class="rail-all flex-shrink-0 fs-6" [routerLink]="`/courses/category/${category.id}`">
          {{ "APP.SHOW_ALL" | translate }}
          <span class="rail-all__arrow" aria-hidden="true">→</span>
        </a>
      </div>

      <div class="row row-cols-1 row-cols-sm-2 row-cols-lg-3 row-cols-xxl-4 g-6">
        @for (
        recommend_course of category.recommend_courses;
        track recommend_course;
        let j = $index
        ) {
        <app-course-item class="hover-elevate-up" [data]="recommend_course"
          [routerLink]="`/courses/${recommend_course.id}`"></app-course-item>
        }
      </div>
    </div>
    }
    }

    <div class="separator mb-8"></div>

    <div class="pb-12">
      <div class="d-flex flex-row justify-content-between align-items-center mb-4">
        <p class="fs-1 fs-md-2 fw-bold mb-0">
          {{ "COURSES.ALL_COURSE" | translate }}
        </p>
        <!-- <button class="btn btn-primary flex-shrink-0 fw-bold">ดูทั้งหมด</button> -->
      </div>

      <div class="min-h-600px">
        <app-course-table-widget [dataColumns]="columns" [dataSource]="dataSource" [isLoading]="tableLoading()"
          (onRowClick)="onRowClick($event)" (tableChange)="onTableChange($event)" [showCardHeader]="true">
          <section table-header class="col-12 pt-3" [formGroup]="form">
            <div class="col-12">
              <div class="row">
                <!-- The catalogue was the only browse page with no way to
                     search it: three selects and a paginator over a wall of
                     similar titles. /blogs has had one all along. -->
                <div class="col-12 col-lg-3 mb-4 mb-lg-0">
                  <app-input name="keywords" formControlName="keywords" data-testid="course-search"
                    placeholder="APP.SEARCH_COURSE" [labelMode]="LabelMode.NO_LABEL"></app-input>
                </div>
                <div class="col-12 col-sm-4 col-lg-3 mb-4 mb-sm-0">
                  <app-select name="course_category_id" formControlName="course_category_id"
                    placeholder="TABLE.CATEGORY" [labelMode]="LabelMode.NO_LABEL" url="/course_categories"></app-select>
                </div>
                <div class="col-12 col-sm-4 col-lg-3 mb-4 mb-sm-0">
                  <app-select name="sort_order" bindLabel="name" bindValue="value" formControlName="order"
                    placeholder="APP.FIRST_NAME" [labelMode]="LabelMode.NO_LABEL" [options]="sortOptions"></app-select>
                </div>
                <!-- The list could already show a "ทดลองเรียน" button per course
                     but gave no way to see only those, so someone looking for
                     something to try had to page through everything. -->
                <div class="col-12 col-sm-4 col-lg-3">
                  <app-select name="has_trial" bindLabel="name" bindValue="value" formControlName="has_trial"
                    placeholder="APP.TRIAL_ONLY" [labelMode]="LabelMode.NO_LABEL" [options]="trialOptions"></app-select>
                </div>
              </div>
            </div>
          </section>
        </app-course-table-widget>
      </div>
    </div>
    }
  </div>

</section>

<ng-template #skeletonGroup>
  <div class="mb-10">
    <div class="skeleton w-100px h-35px mb-4"></div>

    <div class="d-flex flex-column flex-md-row gap-6">
      <ng-container *ngTemplateOutlet="skeleton"></ng-container>
      <ng-container *ngTemplateOutlet="skeleton"></ng-container>
      <ng-container *ngTemplateOutlet="skeleton"></ng-container>
    </div>
  </div>
</ng-template>

<ng-template #skeleton>
  <div class="card min-h-475px w-100 w-md-300px px-0">
    <div class="card-body d-flex flex-column justify-content-between p-8">
      <div class="d-flex flex-column">
        <div class="skeleton h-200px w-100"></div>
        <div class="skeleton h-40px w-100 mt-5 mb-2"></div>
        <div class="skeleton h-30px w-100 mt-2 mb-8"></div>
      </div>
      <div class="d-flex flex-column">
        <div class="separator mt-8"></div>
        <div class="w-100 d-flex flex-row justify-content-between">
          <div class="skeleton h-30px w-80px mt-4"></div>
          <div class="skeleton h-30px w-80px mt-4"></div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #skeletonTable>
  <div class="mb-4">
    <div class="skeleton w-100px h-35px mb-4"></div>
    <div class="card min-h-500px w-100 px-0">
      <div class="card-body d-flex flex-column justify-content-between p-8">
        <div class="row">
          <div class="col-12 col-sm-3 mb-6">
            <div class="skeleton h-40px w-100"></div>
          </div>
          <div class="col-12 col-sm-3 mb-8">
            <div class="skeleton h-40px w-100"></div>
          </div>

          <ng-container *ngTemplateOutlet="skeletonTableItem"></ng-container>
          <div class="separator my-8"></div>
          <ng-container *ngTemplateOutlet="skeletonTableItem"></ng-container>
          <div class="separator my-8"></div>
          <ng-container *ngTemplateOutlet="skeletonTableItem"></ng-container>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #skeletonTableItem>
  <div class="col-12 d-flex flex-column flex-md-row gap-6">
    <div class="skeleton h-150px h-sm-175px h-lg-175px object-fit-cover w-100 w-md-200px mb-4 mb-sm-0"></div>
    <div class="d-flex flex-column justify-content-between flex-fill">
      <div class="mb-4">
        <div class="d-flex flex-row w-100 justify-content-between">
          <div class="d-flex flex-column w-100">
            <div class="skeleton w-100 mw-150px h-30px"></div>
            <div class="skeleton w-100 mw-200px h-25px mt-4"></div>
          </div>
          <div class="d-none d-md-block">
            <ng-container *ngTemplateOutlet="SkeletonStar"></ng-container>
          </div>
        </div>
      </div>
      <div class="d-flex flex-row align-items-center w-100 gap-4">
        <!-- Tutor avatar — now circular in the real content
             (course-table-widget.component.html), so the placeholder shape
             matches instead of resolving into a different one. -->
        <div class="skeleton rounded-circle w-100 mw-30px h-30px"></div>
        <div class="skeleton w-100 mw-125px h-20px"></div>
        <div class="skeleton w-100 mw-80px h-20px"></div>
        <div class="skeleton w-100 mw-80px h-20px"></div>
        <div class="skeleton w-100 mw-80px h-20px"></div>
      </div>
      <div class="d-md-none mt-4">
        <ng-container *ngTemplateOutlet="SkeletonStar"></ng-container>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #SkeletonStar>
  <div class="d-flex flex-row gap-2">
    <div class="skeleton w-20px h-20px"></div>
    <div class="skeleton w-20px h-20px"></div>
    <div class="skeleton w-20px h-20px"></div>
    <div class="skeleton w-20px h-20px"></div>
    <div class="skeleton w-20px h-20px"></div>
  </div>
</ng-template>